import {
	AfterViewChecked,
	AfterViewInit,
	ApplicationRef,
	ChangeDetectorRef,
	Component,
	ComponentFactoryResolver,
	ComponentRef,
	Injector,
	Input,
	OnInit,
	ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
	EstacaoMonitorada,
	FiltrosEstacaoMonitordada,
} from '@home/submodulos/dados-meteorologicos/submodulos/monitoramento/interfaces/estacao-monitorada';
import { TipoEstacao } from '@modulos/meteorologia/submodulos/estacao/enums/tipo-estacao';
import { EstacoesService } from '@home/submodulos/dados-meteorologicos/submodulos/monitoramento/services/estacoes.service';
import { OpcaoFiltroEstacao } from '@home/submodulos/dados-meteorologicos/submodulos/monitoramento/interfaces/monitoramento-estacoes';
import * as Leaflet from 'leaflet';
import { LayerGroup } from 'leaflet';
import { PublicEstacaoPopupComponent } from '@home/submodulos/dados-meteorologicos/submodulos/monitoramento/componentes/public-estacao-popup/public-estacao-popup.component';
import { DataMarker } from '@utils/leaflet';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalFitroMapaMonitoramentoComponent } from '@home/submodulos/dados-meteorologicos/submodulos/monitoramento/pages/estacoes/componentes/modal-fitro-mapa-monitoramento/modal-fitro-mapa-monitoramento.component';
import { StatusEstacao } from '@modulos/meteorologia/submodulos/estacao/enums/status-estacao';
import { ADTColumns } from 'angular-datatables/src/models/settings';
import { OptionRadio } from '@shared/interfaces/public-radio-group';
import { capitalizeFirstLetter, isNuloOuUndefined } from '@utils';
import { DataTablesModule } from 'angular-datatables';
import { PublicTableComponent } from '@componentes/public-table/public-table.component';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';
import { format } from 'date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import * as pdfseira from '@utils/pdf-seira';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as ExcelTable from 'mr-excel';
import { MapaParaibaLeafletComponent } from '@componentes/mapa-paraiba-leaflet/mapa-paraiba-leaflet.component';
import { DocumentExporter } from '@utils/document-exporter';
import { numberToBrNumber } from '../../../../../../../../../../shared/utils/index';
import { corrigeDuplicacaoNome } from '@modulos/home/submodulos/dados-meteorologicos/utils';

const bootstrapLarguraSM = 576;

@Component({
	selector: 'seira-estacoes-monitoramento-mapa',
	templateUrl: './estacoes-monitoramento-mapa.component.html',
	styleUrls: ['./estacoes-monitoramento-mapa.component.scss'],
})
export class EstacoesMonitoramentoMapaComponent
	implements OnInit, AfterViewInit, DataTablesModule, AfterViewChecked
{
	ngOnInit() {
		this.getFormItemValue('opcoesTabela');
		this.fetchEstacoesMonitoradas();
	}
	@ViewChild('tabelaMonitoramento', { static: false })
	tabela!: PublicTableComponent;
	@Input() homePage = false;
	@ViewChild(MapaParaibaLeafletComponent, { static: false })
	mapaParaibaRef?: MapaParaibaLeafletComponent;
	@Input()
	class = 'col col-xl-9 col-12 d-flex flex-column';
	markersLayer: LayerGroup;
	map!: Leaflet.Map;
	isDesktop = window.innerWidth > 1200;
	mostrarCampos = false;
	loadingFiltrando = false;
	private readonly opcaoTodosTabela = 'TODOS';
	markersEstacoes: EstacaoMonitorada[] = [];
	estacoes: OpcaoFiltroEstacao[] = [];
	municipios: OpcaoFiltroEstacao[] = [];
	mesorregioes: OpcaoFiltroEstacao[] = [];
	bacias: OpcaoFiltroEstacao[] = [];
	regioes: OpcaoFiltroEstacao[] = [];
	microrregioes: OpcaoFiltroEstacao[] = [];
	status: { label: StatusEstacao; value: keyof typeof StatusEstacao }[] = [];
	show = 'block';
	tiposEstacao: { label: TipoEstacao; value: keyof typeof TipoEstacao }[] = [];

	formEstacao: FormGroup;
	estacoesMonitoradas: EstacaoMonitorada[] = [];
	estacoesMonitoradasFiltradas: EstacaoMonitorada[] = [];
	estacoesMonitoradasBox: EstacaoMonitorada[] = [];
	tableColumns: ADTColumns[] = [];

	OpcoesTipoVisualizacao: OptionRadio<'mapa' | 'tabela'>[] = [
		{ label: 'Mapa', value: 'mapa' },
		{ label: 'Tabela', value: 'tabela' },
	];

	centerDefault: Leaflet.LatLngExpression = [-7.2605416, -36.7290255];
	zoomDefault = 8;
	modalFiltro?: BsModalRef<ModalFitroMapaMonitoramentoComponent>;
	tabelaRenderizada = false;
	botoesDeExportacao: GroupButton[] = [
		{
			label: '.pdf',
			size: 'small',
			icon: 'ph-file-pdf',
			onClick: () => {
				return this.exportarPDF();
			},
		},
		{
			label: '.csv',
			size: 'small',
			icon: 'ph-file-csv',
			onClick: () => {
				return this.exportarcsv();
			},
		},
		{
			label: '.txt',
			size: 'small',
			icon: 'ph-file-text',
			onClick: () => {
				return this.exportarTXT();
			},
		},
		{
			label: '.xlsx',
			size: 'small',
			icon: 'ph-file-xls',
			onClick: () => this.exportarXLSX(),
		},
	];

	mapeamentoFiltros: Record<string, string> = {
		bacia: 'Bacia',
		municipio: 'Município',
		microrregiao: 'Microrregião',
		mesorregiao: 'Mesorregião',
		regiao: 'Região',
		tipoEstacao: 'Tipo de estação',
	};

	getNomesFiltrosAtivos(): string {
		let nomesFiltros = Object.entries(this.formEstacao.value)
			.filter(
				([key, value]) =>
					Object.keys(this.mapeamentoFiltros).includes(key) && !!value
			)
			.map(([key, value]) => this.mapeamentoFiltros[key]);

		if (nomesFiltros.includes('Mesorregião')) {
			nomesFiltros = nomesFiltros.filter(el => el !== 'Região');
		}
		if (nomesFiltros.includes('Microrregião')) {
			nomesFiltros = nomesFiltros.filter(el => el !== 'Mesorregião');
		}
		if (nomesFiltros.includes('Município')) {
			nomesFiltros = nomesFiltros.filter(el => el !== 'Microrregião');
		}
		return nomesFiltros.join(', ');
	}

	getNameEstacao(estacaoMonitorada: EstacaoMonitorada) {
		return estacaoMonitorada.nomeMunicipio === estacaoMonitorada.nomePosto
			? capitalizeFirstLetter(estacaoMonitorada.nomeMunicipio)
			: capitalizeFirstLetter(estacaoMonitorada.nomeMunicipio) +
					'/' +
					capitalizeFirstLetter(estacaoMonitorada.nomePosto);
	}

	exportarXLSX() {
		const dataFormatada = format(
			new Date(),
			"dd 'de' MMMM 'de' yyyy 'às' HH'h'mm",
			{
				locale: ptBrLocale,
			}
		);
		const nomeArquivo = `Relatorio de Rede de monitoramento de estações agroclimáticas da Paraíba exportado em ${dataFormatada}`;
		const colorPalette = {
			c1: '2C3639',
			c2: 'FFFFFF',
			c3: '000000',
			c4: 'EEEEEE',
		};
		const rowStyle = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
		};
		const headerStyle = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
		};
		const headerStyleCenter = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const rowStyleCenter = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const title = {
			backgroundColor: colorPalette.c2,
			whiteSpace: 'pre',
			color: colorPalette.c3,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
				wrapText: 1,
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const headers = [
			{ label: 'Municipio', text: 'Município/Posto', size: 24 },
			{ label: 'latitude', text: 'Latitude', size: 24 },
			{ label: 'longitude', text: 'Longitude', size: 24 },
			{ label: 'altitude', text: 'Altitude', size: 24 },
			{ label: 'microrregiao', text: 'Microrregião', size: 24 },
			{ label: 'mesorregiao', text: 'Mesorregião', size: 24 },
			{ label: 'regiao', text: 'Região Pluviométrica', size: 24 },
			{ label: 'bacia', text: 'Bacia', size: 24 },
			{ label: 'tipo', text: 'Tipo de estação', size: 24 },
		];
		const dataExcel = {
			styles: {
				headerStyle,
				headerStyleCenter,
				rowStyle,
				rowStyleCenter,
				title,
			},
			sheet: [
				{
					shiftTop: 3,
					images: [
						{
							url: 'assets/images/cabecalho/cabeçalho_excel.png',
							from: 'A1',
							to: 'C3',
						},
					],
					styleCellCondition(
						data: any,
						object: any,
						rowIndex: number,
						colIndex: number
					) {
						if (data && data.label) {
							return 'headerStyleCenter';
						} else {
							if (colIndex === 0) {
								return 'rowStyle';
							} else {
								return 'rowStyleCenter';
							}
						}
					},
					headers: headers,
					data: this.markersEstacoes.map(estacao => {
						return {
							Municipio: corrigeDuplicacaoNome(
								`${estacao.nomeMunicipio}/${estacao.nomePosto}`
							),
							latitude: numberToBrNumber(estacao.latitude, 4) ?? '-',
							longitude: numberToBrNumber(estacao.longitude, 4) ?? '-',
							altitude: numberToBrNumber(estacao.altitude, 1) ?? '-',
							microrregiao: estacao.nomeMicrorregiao ?? '-',
							mesorregiao: estacao.nomeMesorregiao ?? '-',
							regiao: estacao.nomeRegiao ?? '-',
							bacia: estacao.nomeBacia ?? '-',
							tipo:
								estacao.tipoEstacao === 'PLUVIOMETRO_CONVENCIONAL'
									? 'PCO'
									: estacao.tipoEstacao,
						};
					}),
					columns: [
						{ key: 'Municipio' },
						{
							key: 'latitude',
							style: { numFmt: '0,0' },
						},
						{
							key: 'longitude',
							style: { numFmt: '0,0' },
						},
						{
							key: 'altitude',
							style: { numFmt: '0,0' },
						},
						{
							key: 'microrregiao',
						},
						{
							key: 'mesorregiao',
						},
						{
							key: 'regiao',
						},
						{
							key: 'bacia',
						},
					],
					title: {
						consommeRow: 3,
						consommeCol: 3,
						text: `${nomeArquivo}`,
						styleId: 'title',
					},
				},
			],
			fileName: nomeArquivo,
		};
		ExcelTable.generateExcel(dataExcel);
	}
	exportarTXT() {
		const colunas = [
			'Município/Posto',
			'Mesorregião',
			'Microrregião',
			'Região Pluviométrica',
			'Bacia',
			'Latitude',
			'Longitude',
			'Altitude',
			'Tipo de estação',
		];

		let txtData = '';

		this.markersEstacoes.forEach((estacao: EstacaoMonitorada) => {
			const rowData = [
				this.getNameEstacao(estacao),
				estacao.nomeMicrorregiao,
				estacao.nomeMesorregiao,
				estacao.nomeRegiao,
				estacao.nomeBacia ?? '-',
				numberToBrNumber(estacao.latitude, 4),
				numberToBrNumber(estacao.longitude, 4),
				estacao.altitude ? numberToBrNumber(estacao.altitude, 1) : '-',
				estacao.tipoEstacao === 'PLUVIOMETRO_CONVENCIONAL'
					? 'PCO'
					: estacao.tipoEstacao,
			];
			rowData.forEach((data, index) => {
				txtData += `${colunas[index]}: ${data}\n`;
			});
			txtData += '\n';
		});

		DocumentExporter.gerarTXT(txtData, `Rede de monitoramento de estações`);
	}
	async exportarPDF() {
		const img = await this.mapaParaibaRef?.getMapImage();
		const dataFormatada = format(
			new Date(),
			"dd 'de' MMMM 'de' yyyy 'às' HH'h'mm",
			{
				locale: ptBrLocale,
			}
		);

		const documentDefinition: any = await pdfseira.documentDefinitions(
			'landscape'
		);

		documentDefinition.content.push([
			{
				text: `Rede de monitoramento de estações agroclimáticas da Paraíba`,
				alignment: 'center',
				margin: [0, 0, 5, 5],
			},
			{
				text: `Relatório exportado em: ${dataFormatada}`,
				alignment: 'center',
				margin: [0, 5, 5, 5],
				fontSize: 12,
			},
		]);

		if (img !== 'data:,') {
			documentDefinition.content.push({
				image: img,
				width: window.innerWidth > bootstrapLarguraSM ? 515 : 200,
				heigth: window.innerWidth > bootstrapLarguraSM ? 250 : 465,
				margin: [0, 15, 0, 30],
				alignment: 'center',
			});
		}

		if (this.markersEstacoes) {
			documentDefinition.content.push({
				text: 'PCO: Pluviômetro Convencional, PCD: Plataforma de Coleta de Dados.',
				fontSize: 9,
				margin: [0, 5, 70, 10],
			});
			documentDefinition.content.push({
				table: {
					headerRows: 1,
					widths: ['*', '*', '15%', '15%', '10%', '10%', '*', '*', '*'],
					body: this.getDadosTabelaRedeMonitoramento(this.markersEstacoes).map(
						(row, rowIndex) =>
							row.map(cell => ({
								text: cell,
								alignment: 'center',
								fontSize: 7,
								fillColor: rowIndex === 0 ? '#DCDCDC' : null,
							}))
					),
					alignment: 'center',
					layout: 'lightHorizontalLines',
					fontSize: 10,
				},
			});
		}

		const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
		return pdfDocGenerator.open();
	}
	async exportarcsv() {
		const header = [
			['Agência Executiva de Gestão das Águas do Estado da Paraíba\n\n'],
		];

		const tableData = this.getDadosTabelaRedeMonitoramento(
			this.markersEstacoes
		);
		const csvContent = header.concat(tableData);
		const csvString = csvContent.map(row => row.join(';')).join('\n');

		DocumentExporter.gerarCSV(csvString, `Rede de monitoramento`);
	}

	getDadosTabelaRedeMonitoramento(dados: EstacaoMonitorada[]) {
		const tableData: any[][] = [];
		const colunas = [
			'Município/Posto',
			'Mesorregião',
			'Microrregião',
			'Região Pluviométrica',
			'Bacia',
			'Latitude',
			'Longitude',
			'Altitude',
			'Tipo de estação',
		];
		tableData.push(colunas);

		dados.forEach((item: EstacaoMonitorada) => {
			const rowData = [
				this.getNameEstacao(item),
				item.nomeMicrorregiao,
				item.nomeMesorregiao,
				item.nomeRegiao,
				item.nomeBacia ?? '-',
				numberToBrNumber(item.latitude, 4),
				numberToBrNumber(item.longitude, 4),
				item.altitude !== null ? numberToBrNumber(item.altitude, 1) : '-',
				item.tipoEstacao === 'PLUVIOMETRO_CONVENCIONAL'
					? 'PCO'
					: item.tipoEstacao,
			];
			tableData.push(rowData);
		});

		return tableData;
	}

	constructor(
		private formBuilder: FormBuilder,
		private readonly modalService: BsModalService,
		private estacoesService: EstacoesService,
		private resolver: ComponentFactoryResolver,
		private appRef: ApplicationRef,
		private injector: Injector,
		private cdr: ChangeDetectorRef
	) {
		for (const tipoEstacaoKey in TipoEstacao) {
			const key = tipoEstacaoKey as keyof typeof TipoEstacao;
			if (TipoEstacao[key] !== TipoEstacao.FLUVIOMETRO) {
				this.tiposEstacao.push({ value: key, label: TipoEstacao[key] });
			}
		}
		for (const statusEstacaoKey in StatusEstacao) {
			const key = statusEstacaoKey as keyof typeof StatusEstacao;
			this.status.push({ value: key, label: StatusEstacao[key] });
		}

		this.formEstacao = this.formBuilder.group({
			nomePosto: new FormControl<number | null>(null),
			tipoEstacao: new FormControl<TipoEstacao | null>(null),
			mesorregiao: new FormControl<number | null>(null),
			municipio: new FormControl<number | null>(null),
			periodo: new FormControl(''),
			statusEstacao: new FormControl<StatusEstacao | null>(null),
			bacia: new FormControl<number | null>(null),
			regiao: new FormControl<number | null>(null),
			microrregiao: new FormControl<number | null>(null),
			tipoVisualizacao: new FormControl('mapa'),
			opcoesTabela: new FormControl(this.opcaoTodosTabela),
		});
		this.markersLayer = Leaflet.layerGroup();
	}

	ngAfterViewChecked() {
		if (this.tabela && this.tabelaRenderizada) {
			this.tabelaRenderizada = false;
		}
	}

	ngAfterViewInit() {
		this.loadTabela();
		this.cdr.detectChanges();
	}

	getFormItemValue(formValue: string) {
		return this.formEstacao.get(formValue)!.value;
	}
	loadTabela() {
		this.tableColumns = [
			{
				title: 'Município/Posto',
				data: null,
				className: 'text-tertiary  text-center',
				render: (row: EstacaoMonitorada) => {
					return this.getNameEstacao(row);
				},
			},

			{
				title: 'Tipo de estação',
				data: 'tipoEstacao',
				className: 'text-tertiary  text-center',
				render: function (data) {
					return data === 'PLUVIOMETRO_CONVENCIONAL' ? 'PCO' : data;
				},
			},
			{
				title: 'Latitude',
				data: 'latitude',
				className: 'text-tertiary  text-center',
				render: function (data) {
					return isNuloOuUndefined(data) ? '-' : numberToBrNumber(data, 4);
				},
			},
			{
				title: 'Longitude',
				data: 'longitude',
				className: 'text-tertiary  text-center',
				render: function (data) {
					return isNuloOuUndefined(data) ? '-' : numberToBrNumber(data, 4);
				},
			},
			{
				title: 'Altitude',
				data: 'altitude',
				className: 'text-tertiary  text-center',
				render: function (data) {
					return isNuloOuUndefined(data) ? '-' : numberToBrNumber(data, 1);
				},
			},
		];
	}

	async setupMap(mapa: Leaflet.Map) {
		this.map = mapa;
		this.cdr.detectChanges();
		this.setupMapEvents();
	}

	setupMapEvents() {
		this.map?.on('moveend', () => {
			const markers = this.getMarkersInView();
			const markerIds = markers.map(marker => marker?.data?.id);

			this.estacoesMonitoradasBox = this.markersEstacoes.filter(estacao =>
				markerIds.includes(estacao.id)
			);
		});

		this.map?.on('zoomend', () => {
			const zoomToIconSizeMap: Record<number, number> = {
				8: 15,
				9: 25,
				10: 35,
				11: 45,
			};
			const markers = this.getMarkers();
			const zoom = this.map.getZoom();

			for (const marker of markers) {
				if (marker.data) {
					let newIconSize = zoomToIconSizeMap[zoom] || 15;

					if (zoom < 8) {
						newIconSize = 15;
					} else if (zoom > 11) {
						newIconSize = 45;
					}

					marker.setIcon(this.setIcon(marker.data, newIconSize));
				}
			}
		});
	}

	getMarkers() {
		const markerList: DataMarker<EstacaoMonitorada>[] = [];
		this.map?.eachLayer(layer => {
			markerList.push(layer as DataMarker<EstacaoMonitorada>);
		});
		return markerList;
	}

	getMarkersInView() {
		const markerList: DataMarker<EstacaoMonitorada>[] = [];
		this.map?.eachLayer(layer => {
			if (
				layer instanceof Leaflet.Marker &&
				this.map?.getBounds().contains(layer.getLatLng())
			) {
				markerList.push(layer as DataMarker<EstacaoMonitorada>);
			}
		});
		return markerList;
	}

	filtraVariavel(listaVariavel: number[]) {
		const variaveis = [
			{ id: 'mesorregiaoId', variavel: 'mesorregiao', nome: 'nomeMesorregiao' },
			{ id: 'regiaoId', variavel: 'regiao', nome: 'nomeRegiao' },
			{
				id: 'microrregiaoId',
				variavel: 'microrregiao',
				nome: 'nomeMicrorregiao',
			},
			{ id: 'municipioId', variavel: 'municipio', nome: 'nomeMunicipio' },
			{ id: 'baciaId', variavel: 'bacia', nome: 'nomeBacia' },
			{ id: 'id', variavel: 'nomePosto', nome: 'nomePosto' },
		];
		this.estacoesMonitoradasFiltradas = this.estacoesMonitoradas;
		listaVariavel.forEach((n: number) => {
			const id: string = variaveis[n]?.id;
			const alteraId: string = variaveis[n + 1]?.id;
			const variavel: string = variaveis[n]?.variavel;
			const nome: string = variaveis[n + 1]?.nome;
			const setVariavel: Set<number> = new Set();
			const variavelLista: OpcaoFiltroEstacao[] = [];

			if (this.formEstacao.get(variavel)?.value) {
				this.estacoesMonitoradasFiltradas = this.estacoesMonitoradas.filter(
					(em: EstacaoMonitorada) => {
						return em[id] === this.formEstacao.get(variavel)?.value;
					}
				);
			}

			this.estacoesMonitoradasFiltradas.forEach(
				(estacao: EstacaoMonitorada) => {
					const nomePosto = `${estacao.nomePosto}/ ${estacao.nomeMunicipio} (${
						estacao.tipoEstacao === 'PLUVIOMETRO_CONVENCIONAL'
							? 'Convencional'
							: estacao.tipoEstacao
					})`;
					if (estacao[alteraId] && !setVariavel.has(estacao[alteraId])) {
						variavelLista.push({
							id: estacao[alteraId],
							nome: variavel === 'municipio' ? nomePosto : estacao[nome],
							estacao,
						});
						setVariavel.add(estacao[alteraId]);
					}
				}
			);

			variavelLista?.sort((a, b) => a.nome.localeCompare(b.nome));

			if (variavel === 'mesorregiao') {
				this.mesorregioes = variavelLista;
			}
			if (variavel === 'regiao') {
				this.regioes = variavelLista;
			}
			if (variavel === 'microrregiao') {
				this.microrregioes = variavelLista;
			}
			if (variavel === 'municipio') {
				this.estacoes.push(...variavelLista);
			}
		});
	}

	setSelects(estacoesMonitoradas: EstacaoMonitorada[]) {
		const setMesorregiao: Set<number> = new Set();
		const setRegiao: Set<number> = new Set();
		const setMicrorregiao: Set<number> = new Set();
		const setMunicipio: Set<number> = new Set();
		const setBacia: Set<number> = new Set();
		const mesorregioes: OpcaoFiltroEstacao[] = [];
		const regioes: OpcaoFiltroEstacao[] = [];
		const microrregioes: OpcaoFiltroEstacao[] = [];
		const municipios: OpcaoFiltroEstacao[] = [];
		const bacias: OpcaoFiltroEstacao[] = [];
		const postos: OpcaoFiltroEstacao[] = [];

		estacoesMonitoradas.forEach((estacao: EstacaoMonitorada) => {
			if (estacao.mesorregiaoId && !setMesorregiao.has(estacao.mesorregiaoId)) {
				mesorregioes.push({
					id: estacao.mesorregiaoId,
					nome: estacao.nomeMesorregiao,
					estacao,
				});
				setMesorregiao.add(estacao.mesorregiaoId);
			}
			if (estacao.regiaoId && !setRegiao.has(estacao.regiaoId)) {
				regioes.push({
					id: estacao.regiaoId,
					nome: estacao.nomeRegiao,
					estacao,
				});
				setRegiao.add(estacao.regiaoId);
			}
			if (
				estacao.microrregiaoId &&
				!setMicrorregiao.has(estacao.microrregiaoId)
			) {
				microrregioes.push({
					id: estacao.microrregiaoId,
					nome: estacao.nomeMicrorregiao,
					estacao,
				});
				setMicrorregiao.add(estacao.microrregiaoId);
			}
			if (estacao.municipioId && !setMunicipio.has(estacao.municipioId)) {
				municipios.push({
					id: estacao.municipioId,
					nome: estacao.nomeMunicipio,
					estacao,
				});
				setMunicipio.add(estacao.municipioId);
			}
			if (estacao.baciaId && !setBacia.has(estacao.baciaId)) {
				bacias.push({
					id: estacao.baciaId,
					nome: estacao.nomeBacia,
					estacao,
				});
				setBacia.add(estacao.baciaId);
			}

			if (
				estacao.tipoEstacao === 'PCD' ||
				estacao.tipoEstacao === 'PLUVIOMETRO_CONVENCIONAL'
			) {
				postos.push({
					id: estacao.id,
					nome: ` ${corrigeDuplicacaoNome(
						`${estacao.nomeMunicipio}/${estacao.nomePosto}`
					)} (${
						estacao.tipoEstacao === 'PLUVIOMETRO_CONVENCIONAL'
							? 'convencional'
							: estacao.tipoEstacao
					})`,
				});
			}
		});

		mesorregioes.sort((a, b) => a.nome.localeCompare(b.nome));
		regioes.sort((a, b) => a.nome.localeCompare(b.nome));
		microrregioes.sort((a, b) => a.nome.localeCompare(b.nome));
		municipios.sort((a, b) => a.nome.localeCompare(b.nome));
		bacias.sort((a, b) => a.nome.localeCompare(b.nome));
		postos.sort((a, b) => a.nome.localeCompare(b.nome));

		if (this.mesorregioes.length < 1) {
			this.mesorregioes = mesorregioes;
			this.regioes = regioes;
			this.microrregioes = microrregioes;
			this.municipios = municipios;
			this.bacias = bacias;
			this.estacoes = postos;
		}
		if (this.isPrimeiraConsulta) {
			this.mesorregioesIniciais = [...mesorregioes];
			this.baciasIniciais = [...bacias];
			this.municipiosIniciais = [...municipios];
			this.regioesIniciais = [...regioes];
			this.microrregioesIniciais = [...microrregioes];
			this.isPrimeiraConsulta = false;
		}
	}

	mesorregioesIniciais: OpcaoFiltroEstacao[];
	regioesIniciais: OpcaoFiltroEstacao[];
	microrregioesIniciais: OpcaoFiltroEstacao[];
	municipiosIniciais: OpcaoFiltroEstacao[];
	baciasIniciais: OpcaoFiltroEstacao[];
	isPrimeiraConsulta = true;

	get filtros() {
		const { tipoEstacao, mesorregiao, municipio, bacia, regiao, microrregiao } =
			this.formEstacao.getRawValue();
		return new FiltrosEstacaoMonitordada(
			null,
			tipoEstacao,
			mesorregiao,
			municipio,
			null,
			bacia,
			regiao,
			microrregiao
		);
	}

	possuiFiltrosAtivos(): boolean {
		const { bacia, municipio, microrregiao, mesorregiao, regiao, tipoEstacao } =
			this.formEstacao.value;
		return !!(
			bacia ||
			municipio ||
			microrregiao ||
			mesorregiao ||
			regiao ||
			tipoEstacao
		);
	}

	fetchEstacoesMonitoradas(filtrarSelectsSemFluviometro = true) {
		this.loadingFiltrando = true;
		this.estacoesService.estacoesMonitoramento(this.filtros).subscribe({
			next: estacoes => {
				const estacoesSemTipoFluviometro = estacoes.filter(
					e => e.tipoEstacao !== 'FLUVIOMETRO'
				);
				this.estacoesMonitoradasFiltradas = estacoesSemTipoFluviometro;
				this.markersEstacoes = this.estacoesMonitoradasFiltradas;

				if (filtrarSelectsSemFluviometro) {
					this.setSelects(estacoesSemTipoFluviometro);
				}
				this.loadingFiltrando = false;
				if (
					this.filtros.estacaoId ||
					this.filtros.tipoEstacao ||
					this.filtros.mesorregiaoId ||
					this.filtros.municipioId ||
					this.filtros.statusEstacao ||
					this.filtros.baciaId ||
					this.filtros.regiaoId ||
					this.filtros.microrregiaoId
				) {
					this.setupMarkers(true);
				} else {
					this.setupMarkers(false);
				}
			},
			error: () => {
				this.loadingFiltrando = false;
			},
		});
	}

	setupMarkers(zoomIn: boolean) {
		this.markersLayer.clearLayers();
		this.markersEstacoes
			.filter(estacao => estacao.tipoEstacao !== 'FLUVIOMETRO')
			.forEach(markerPoint => {
				const marker = new DataMarker<EstacaoMonitorada>(
					[markerPoint.latitude, markerPoint.longitude],
					{
						icon: this.setIcon(markerPoint),
						data: markerPoint,
					}
				);
				const markerPopup = this.compilePopup(c => {
					c.instance.markerData = markerPoint;
				});

				marker.bindPopup(markerPopup, {
					closeButton: false,
				});
				marker.addTo(this.markersLayer);
			});
		if (zoomIn) {
			const markerPositions: Leaflet.LatLngBoundsLiteral =
				this.markersEstacoes.map(m => [m.latitude, m.longitude]);
			this.map.fitBounds(markerPositions, {
				maxZoom: 15,
			});
		}

		this.map.setView(this.centerDefault, this.zoomDefault);
	}

	setIcon(estacao: EstacaoMonitorada, size = 15) {
		return Leaflet.icon({
			iconUrl: `assets/images/estacoes/${this.setIconName(
				estacao.tipoEstacao
			)}-${this.setIconStatus(estacao.ultimaColeta)}.svg`,
			iconSize: [size, size],
		});
	}

	setIconName(tipoEstacao: keyof typeof TipoEstacao) {
		let tipoEstacaoIcone: 'pcd' | 'pluviometro-convencional';
		if (tipoEstacao === 'PCD') {
			tipoEstacaoIcone = 'pcd';
		} else {
			tipoEstacaoIcone = 'pluviometro-convencional';
		}
		return tipoEstacaoIcone;
	}

	setIconStatus(ultimaColeta: Date) {
		const dataAtual = new Date();
		dataAtual.setHours(0, 0, 0, 0);
		const dataUltimaColeta = new Date(ultimaColeta);
		dataUltimaColeta.setHours(0, 0, 0, 0);

		const dadosEnviadosNoDia =
			dataAtual.getTime() === dataUltimaColeta.getTime();

		if (dadosEnviadosNoDia) {
			return '1';
		} else {
			return '2';
		}
	}

	compilePopup(
		onAttach: (el: ComponentRef<PublicEstacaoPopupComponent>) => void
	) {
		const compFactory = this.resolver.resolveComponentFactory(
			PublicEstacaoPopupComponent
		);
		const compRef = compFactory.create(this.injector);

		// onAttach allows you to assign
		if (onAttach) onAttach(compRef);

		this.appRef.attachView(compRef.hostView);
		compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));

		const div = document.createElement('div');
		div.appendChild(compRef.location.nativeElement);
		return div;
	}

	mostrarCamposAdicionais() {
		this.mostrarCampos = !this.mostrarCampos;
		return this.mostrarCampos;
	}

	salvarFiltrosEBuscarEstacoesMonitoradas(filtro: FiltrosEstacaoMonitordada) {
		this.formEstacao.patchValue({
			estacaoId: null,
			tipoEstacao: filtro.tipoEstacao,
			mesorregiao: filtro.mesorregiaoId,
			bacia: filtro.baciaId,
			regiao: filtro.regiaoId,
			microrregiao: filtro.microrregiaoId,
			municipio: filtro.municipioId,
		});
		this.fetchEstacoesMonitoradas(false);
	}

	abrirModalFiltros(event: Event) {
		event.preventDefault();
		const {
			baciasIniciais,
			municipiosIniciais,
			microrregioesIniciais,
			mesorregioesIniciais,
			regioesIniciais,
		} = this;
		const config = {
			class: 'modal-dialog-centered',
			initialState: {
				filtro: this.filtros,
				intervaloMonitoramento: this.formEstacao.get('statusEstacao')?.value,
				regioesIniciais,
				baciasIniciais,
				microrregioesIniciais,
				municipiosIniciais,
				mesorregioesIniciais,
				tiposEstacao: this.tiposEstacao,
				estacoesMonitoradas: this.estacoesMonitoradas,
				enviarFiltro: (filtro: any) =>
					this.salvarFiltrosEBuscarEstacoesMonitoradas(filtro),
			},
		};

		this.modalFiltro = this.modalService.show(
			ModalFitroMapaMonitoramentoComponent,
			config as ModalOptions
		);
	}

	filtrarPostosPorTipoEstacao(tipoEstacao: TipoEstacao | null) {
		let postosFiltrados: EstacaoMonitorada[];

		if (tipoEstacao !== null) {
			postosFiltrados = this.estacoesMonitoradas.filter(
				estacao => estacao.tipoEstacao === tipoEstacao
			);
		} else {
			postosFiltrados = this.estacoesMonitoradas;
		}

		this.estacoes = postosFiltrados.map(posto => ({
			id: posto.id,
			nome: ` ${corrigeDuplicacaoNome(
				`${posto.nomeMunicipio}/${posto.nomePosto}`
			)} (${
				posto.tipoEstacao === 'PLUVIOMETRO_CONVENCIONAL'
					? 'convencional'
					: posto.tipoEstacao
			})`,
		}));

		this.formEstacao.get('nomePosto')?.setValue(null);
	}
}
